// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3Se4B","rootCenter":"LoadMoreObserver_rootCenter__3Swkv","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__3jXOc"};